/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown>, plan: NonNullable<unknown> }} Ticketsfeeline2Inputs */

const en_ticketsfeeline2 = /** @type {(inputs: Ticketsfeeline2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee} per paid ticket on the ${i?.plan} plan. Free tickets cost nothing.`)
};

const de_ticketsfeeline2 = /** @type {(inputs: Ticketsfeeline2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee} pro bezahltem Ticket im Plan ${i?.plan}. Kostenlose Tickets kosten nichts.`)
};

/**
* | output |
* | --- |
* | "{fee} per paid ticket on the {plan} plan. Free tickets cost nothing." |
*
* @param {Ticketsfeeline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfeeline2 = /** @type {((inputs: Ticketsfeeline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfeeline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfeeline2(inputs)
	return de_ticketsfeeline2(inputs)
});
export { ticketsfeeline2 as "ticketsFeeLine" }